// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketFilledSvg from "@ant-design/icons-svg/es/asn/RocketFilled";
import AntdIcon from '../components/AntdIcon';

var RocketFilled = function RocketFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketFilledSvg
  }));
};

RocketFilled.displayName = 'RocketFilled';
export default React.forwardRef(RocketFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RocketFilled.js
// module id = 1727
// module chunks = 0